import { Pipe, PipeTransform } from "@angular/core";
import { MD5 } from "crypto-js";
import { hash } from "../support/string";

const URLS = [
  "https://www.cartoonizemypet.com/builder/thumbs/pets/dogs/akita-inu/red-db.png",
  "https://www.cartoonizemypet.com/builder/thumbs/pets/dogs/beagle2/lemon-with-blue-saddle.png",
  "https://www.cartoonizemypet.com/builder/thumbs/pets/cats/british-shorthair/sepia-ablue2.png",
  "https://www.cartoonizemypet.com/builder/thumbs/pets/cats/maine-coon/a-calico-chocolate.png"
];
@Pipe({
  name: "gravatarUrl",
  standalone: false
})
export class GravatarUrlPipe implements PipeTransform {
  transform(
    value: string,
    size: number = 32,
    mode: "contact" | "patient" = "contact"
  ): string {
    switch (mode) {
      case "patient": {
        const id = Math.abs((hash(value) % 4) + 1);
        return URLS[id];
      }
      case "contact":
      default: {
        return `http://www.gravatar.com/avatar/${MD5(
          value
        ).toString()}.jpg?s=${size}&d=mp`;
      }
    }
  }
}
